module.exports = __webpack_public_path__ + "img/17-04_Demonstrating Good Judgement.4bb35b35.svg";